import { render, staticRenderFns } from "./AgentC.vue?vue&type=template&id=8dc92ad0&scoped=true&"
import script from "./AgentC.vue?vue&type=script&lang=js&"
export * from "./AgentC.vue?vue&type=script&lang=js&"
import style0 from "./AgentC.vue?vue&type=style&index=0&id=8dc92ad0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc92ad0",
  null
  
)

export default component.exports